import axios from 'axios';
import getApiUrl from "src/utils/get-api-url";

const apiUrl = getApiUrl();

/**
 * Get all needs with optional filters.
 * 
 * @param {Object} [filters] 
 * @param {string} [filters.site] 
 * @param {string} [filters.team] 
 * @param {string} [filters.client] 
 * @param {string} [filters.role]
 * @param {string} [filters.technology]
 * @param {string} [filters.level]
 * @param {string} [filters.englishLevel]
 * @returns {Promise<Object>}
 */
export function list(filters = {}) {
    return axios.get(`${apiUrl}/need`, {params: filters});
}
